/**
 * Ticket generation from the requirements register
 * (CR-BUILD-BOARD-EPICS-2026-09-26): `POST …/versions/:versionId/generate-tickets`
 * (`TicketGenerationController.generate`, PX-W4.5) answers `text/event-stream`.
 * One transport — `apiClient.postEventStream` — and the body is always `{}`:
 * this client never sends `force` (spec R.6.5).
 */

import { apiClient } from '@/services'
import type { SseFrame } from '@/services/sseFrames'

export const ticketGenerationService = {
  /**
   * Opens one generation stream for the version; `onFrame` receives every SSE
   * frame in order. Resolves when the server closes the stream, rejects with
   * an `ApiError` on a pre-stream refusal, and with the abort error when
   * `signal` aborts.
   */
  generate(
    orgId: string,
    projectId: string,
    versionSlug: string,
    onFrame: (frame: SseFrame) => void,
    signal: AbortSignal
  ): Promise<void> {
    return apiClient.postEventStream(
      `/${orgId}/projects/${encodeURIComponent(projectId)}/versions/${encodeURIComponent(versionSlug)}/generate-tickets`,
      {},
      { onFrame, signal }
    )
  }
}
